const apiKey = "b600926e667cc35f8fa495b890a0b4a0";
const apiUrl = "https://api.themoviedb.org/3/";

const imgBaseUrl = "https://image.tmdb.org/t/p/";
const imgBig = "w1280";
const imgPoster = "w500";


export {
    apiKey,
    apiUrl,
    imgBaseUrl,
    imgBig,
    imgPoster
}